"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoadingFactory = exports.bootstrapServer = exports.bootstrapClient = exports.renderMFE = exports.importReactRemote = exports.initializeWebComponent = exports.serverSideMountFactory = exports.getAllRemoteDependenciesFrom = exports.useDisableEditContent = exports.clientSideUnmountFactory = exports.clientSideMountFactory = void 0;
var utils_1 = require("../../utils");
var common_mfe_1 = require("../common-mfe");
var main_1 = require("../../main");
var Console_helper_1 = require("../../helpers/Console.helper");
var EditContent_helper_1 = require("../../helpers/EditContent.helper");
function clientSideMountFactory(_a, App, roots) {
    var createRoot = _a.createRoot, hydrateRoot = _a.hydrateRoot, createElement = _a.createElement;
    return function (el, props, options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve, reject) {
            var _a = options.isMounting, isMounting = _a === void 0 ? false : _a;
            var id = props.id, __serverSideHtml__ = props.__serverSideHtml__;
            if (isMounting) {
                if (__serverSideHtml__) {
                    roots[id] = hydrateRoot(el, createElement(App, props), {
                        identifierPrefix: id,
                        onRecoverableError: function () {
                            // do nothing
                        },
                    });
                }
                else {
                    roots[id] = createRoot(el, { identifierPrefix: id });
                    roots[id].render(createElement(App, props));
                }
                resolve({});
            }
            else if (id in roots && typeof roots[id].render === "function") {
                roots[id].render(createElement(App, props));
                resolve({});
            }
            else {
                reject(new Error("[Client Side Mount] Error: Cannot update a not mounted component"));
            }
        });
    };
}
exports.clientSideMountFactory = clientSideMountFactory;
function clientSideUnmountFactory(roots) {
    return function (_, props) {
        var id = props.id;
        return new Promise(function (resolve) {
            if (!!id && !!roots[id]) {
                roots[id].unmount();
                delete roots[id];
            }
            resolve({});
        });
    };
}
exports.clientSideUnmountFactory = clientSideUnmountFactory;
function useDisableEditContent(_a, ref, parentId, name) {
    var _b = _a === void 0 ? {} : _a, useEffect = _b.useEffect;
    useEffect(function () {
        if (window) {
            var handleInlineRichText_1 = function (event) {
                var editModeSettingsIconColl = document.getElementsByClassName("edit-mode-settings-icon");
                var editModeDeleteIconColl = document.getElementsByClassName("edit-mode-delete-icon");
                var boilerPlateColl = document.getElementsByClassName("boilerplate-container ");
                EditContent_helper_1.EditContentHelper.disableEditContent(event, ref, [
                    editModeSettingsIconColl,
                    editModeDeleteIconColl,
                    boilerPlateColl,
                ]);
            };
            // Add event listener
            window.addEventListener("".concat(EditContent_helper_1.EditContentHelper.richTextInlineEvent(), "-").concat(parentId), handleInlineRichText_1);
            // Remove event listener when the component unmounts
            return function () {
                window.removeEventListener("".concat(EditContent_helper_1.EditContentHelper.richTextInlineEvent(), "-").concat(parentId), handleInlineRichText_1);
            };
        }
    }, []);
}
exports.useDisableEditContent = useDisableEditContent;
function getAllRemoteDependenciesFrom(childrenRemoteDeps, containerProps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    return Object.entries(childrenRemoteDeps)
        .map(function (_a) {
        var __mfeName__ = _a[0], getRemoteDependencies = _a[1].getRemoteDependencies;
        try {
            return getRemoteDependencies && getRemoteDependencies(containerProps);
        }
        catch (error) {
            return null;
        }
    })
        .flat()
        .filter(function (el) { return !!el; });
}
exports.getAllRemoteDependenciesFrom = getAllRemoteDependenciesFrom;
function serverSideMountFactory(_a, Component, childrenRemoteDeps) {
    var renderToString = _a.renderToString, createElement = _a.createElement;
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    return function (props) {
        var allRemoteDependencies = getAllRemoteDependenciesFrom(childrenRemoteDeps, props);
        return importReactRemote(props, allRemoteDependencies).then(function (newProps) {
            var html = renderToString(createElement(Component, newProps));
            return { html: html };
        });
    };
}
exports.serverSideMountFactory = serverSideMountFactory;
function initializeWebComponent(__mfeName__, clientSideMount, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    var selector = (0, utils_1.getWebComponentMFENameBy)(__mfeName__);
    return (0, common_mfe_1.initializeComponent)(selector, __mfeName__, clientSideMount, childrenRemoteDeps);
}
exports.initializeWebComponent = initializeWebComponent;
// Used served side only
function importReactRemote(props, allRemoteDependencies) {
    if (allRemoteDependencies === void 0) { allRemoteDependencies = []; }
    var importMFE = main_1.CommonMFE.importMFEFactory(props);
    var childrenRemotesDependencies = (0, utils_1.generateChildrenRemotesDependencies)(allRemoteDependencies);
    return Promise.allSettled(Object.entries(childrenRemotesDependencies).map(function (_a) {
        var remoteName = _a[0], remoteDependenciesMap = _a[1];
        return importMFE(remoteName).then(function (remote) {
            return renderMFE(remoteDependenciesMap, importMFE, remote);
        });
    })).then(function () { return props; });
}
exports.importReactRemote = importReactRemote;
function renderMFE(remoteDependenciesMap, importMFE, remote) {
    if (remote === void 0) { remote = null; }
    return Promise.allSettled(Object.entries(remoteDependenciesMap).map(function (_a) {
        var _ = _a[0], remoteDependency = _a[1];
        var remoteProps = remoteDependency.props;
        return remote
            .serverSideMount(__assign(__assign({}, remoteProps), { __host__: { importMFEBy: importMFE } }))
            .then(function (module) {
            remoteProps.__serverSideHtml__ = module.html.replaceAll("\x3C", "<");
        });
    }));
}
exports.renderMFE = renderMFE;
function bootstrapClient(__ReactDeps__, __mfeName__, App) {
    var roots = {};
    return {
        __mfeName__: __mfeName__,
        clientSideMount: clientSideMountFactory(__ReactDeps__, App, roots),
        clientSideUnmount: clientSideUnmountFactory(roots),
    };
}
exports.bootstrapClient = bootstrapClient;
function bootstrapServer(__ReactDeps__, __mfeName__, App, childrenRemoteDeps) {
    if (childrenRemoteDeps === void 0) { childrenRemoteDeps = {}; }
    return {
        __mfeName__: __mfeName__,
        serverSideMount: serverSideMountFactory(__ReactDeps__, App, childrenRemoteDeps),
        childrenRemoteDeps: childrenRemoteDeps,
    };
}
exports.bootstrapServer = bootstrapServer;
function LazyLoadingFactory(_a, importFunc) {
    var useEffect = _a.useEffect, useState = _a.useState, createElement = _a.createElement;
    return function (props) {
        var _a = useState(function () { return function () { return createElement("div", {}, "Loading..."); }; }), Component = _a[0], setComponent = _a[1];
        useEffect(function () {
            importFunc()
                .then(function (res) {
                setComponent(function () { return res.default; });
            })
                .catch(function (err) {
                Console_helper_1.ConsoleHelper.error(err);
            });
        }, []);
        return createElement(Component, props);
    };
}
exports.LazyLoadingFactory = LazyLoadingFactory;
